import request from '@/utils/request'

export function createAgentPreOrderItem(data) {
  return request({
    url: `/agent_pre_order_items`,
    method: 'post',
    data
  })
}

export function findPreOrderItemLastRemarks(params) {
  return request({
    url: `/agent_pre_order_items/find_last_remarks`,
    method: 'get',
    params: params
  })
}

// 查询单个预制项目
export function findAgentPreOrderItem(id) {
  return request({
    url: `/agent_pre_order_items/${id}`,
    method: 'get'
  })
}

// 核库项目
export function checkStoreAgentPreOrderItem(id, data) {
  return request({
    url: `/agent_pre_order_items/${id}/check_store`,
    method: 'post',
    data
  })
}

// 核资项目
export function checkResourceAgentPreOrderItem(id, data) {
  return request({
    url: `/agent_pre_order_items/${id}/check_resource`,
    method: 'post',
    data
  })
}

// 取消项目
export function cancelAgentPreOrderItem(id, data) {
  return request({
    url: `/agent_pre_order_items/${id}/cancel`,
    method: 'post',
    data
  })
}

// 将预制项目放到购物车
export function putAgentPreOrderItemToCart(id) {
  return request({
    url: `/agent_pre_order_items/${id}/put_to_cart`,
    method: 'post'
  })
}

// 查询订单项目状态
export function findAgentPreOrderItemStatusOptions() {
  return request({
    url: `/agent_pre_order_items/status_options`,
    method: 'get'
  })
}

// 完成项目
export function finishedAgentPreOrderItem(id, data) {
  return request({
    url: `/agent_pre_order_items/${id}/finished`,
    method: 'post',
    data
  })
}
